import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ breakpoints, spacing, tokens }, { mb, mt })=>{
    var _mt_xs, _mb_xs, _mt_sm, _mb_sm, _mt_md, _mb_md;
    return {
        documentCursor: {
            cursor: 'pointer'
        },
        square: {
            paddingTop: '100%'
        },
        dialogPaper: {
            '&, &.MuiDialog-paperFullScreen.MuiDialog-paperScrollBody': {
                [breakpoints.up('xs')]: {
                    marginTop: spacing(5.2),
                    marginBottom: spacing(6.4)
                },
                [breakpoints.up('sm')]: {
                    marginTop: 0
                },
                [breakpoints.up('md')]: {
                    marginTop: tokens.spacing['32'],
                    marginBottom: spacing(9.8)
                }
            },
            '&.MuiDialog-paperFullScreen': {
                [breakpoints.up('xs')]: {
                    height: 'max-content'
                },
                [breakpoints.up('sm')]: {
                    height: 'max-content'
                }
            }
        },
        paper: {
            '&, &.MuiDialog-paperFullScreen.MuiDialog-paperScrollBody': {
                [breakpoints.up('xs')]: {
                    marginTop: spacing(null != (_mt_xs = mt.xs) ? _mt_xs : 0),
                    marginBottom: spacing(null != (_mb_xs = mb.xs) ? _mb_xs : 0)
                },
                [breakpoints.up('sm')]: {
                    marginTop: spacing(null != (_mt_sm = mt.sm) ? _mt_sm : 0),
                    marginBottom: spacing(null != (_mb_sm = mb.sm) ? _mb_sm : 0)
                },
                [breakpoints.up('md')]: {
                    marginTop: spacing(null != (_mt_md = mt.md) ? _mt_md : 0),
                    marginBottom: spacing(null != (_mb_md = mb.md) ? _mb_md : 0)
                }
            },
            '&.MuiDialog-paperFullScreen': {
                [breakpoints.up('xs')]: {
                    maxHeight: `calc(100% - ${(mt.xs ? 10 * mt.xs : 0) + (mb.xs ? 10 * mb.xs : 0)}px)`
                },
                [breakpoints.up('sm')]: {
                    maxHeight: `calc(100% - ${(mt.sm ? 10 * mt.sm : 0) + (mb.sm ? 10 * mb.sm : 0)}px)`
                },
                [breakpoints.up('md')]: {
                    maxHeight: `calc(100% - ${(mt.md ? 10 * mt.md : 0) + (mb.md ? 10 * mb.md : 0)}px)`
                }
            }
        },
        errorFile: {
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: tokens.spacing['16']
        }
    };
});
export { useStyles };
